import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class CustomValidatorsService {

  constructor() { }

  MatchValidator(controlName: string, matchingControlName: string): ValidatorFn {
    return (controls: AbstractControl): ValidationErrors | null => {
      const control = controls.get(controlName);
      const matchingControl = controls.get(matchingControlName);

      if (!control || !matchingControl) {
        return null;
      }

      return control.value === matchingControl.value ? null : { mismatch: true };
    };
  }

}